import React from "react";
import NavBar from "../components/NavBar";
const Parcours = () => {
  return (
    <>
      <NavBar />
      <div class="container px-5 my-5">
        <div class="text-center mb-5">
          <h1 class="display-5 fw-bolder mb-0">
            <span class="text-gradient d-inline">Parcours</span>
          </h1>
        </div>
        <div class="row gx-5 justify-content-center">
          <div class="col-lg-11 col-xl-9 col-xxl-8">
            <section>
              <div class="d-flex align-items-center justify-content-between mb-4">
                <h2 class="text-primary fw-bolder mb-0">Expérience</h2>
               {/*  <a class="btn btn-primary px-4 py-3" href="#!">
                  <div class="d-inline-block bi bi-download me-2"></div>
                  Telecharger CV
                </a> */}
              </div>
              <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">
                  <div class="row align-items-center gx-5">
                    <div class="col text-center text-lg-start mb-4 mb-lg-0">
                      <div class="bg-light p-4 rounded-4">
                        <div class="text-primary fw-bolder mb-2">
                          2022 - Présent
                        </div>
                        <div class="small fw-bolder">Développeur web</div>
                        <div class="small text-muted">FullStack</div>
                        <div class="small text-muted">Chez BPO</div>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div>
                        Développement d'application web. Principalement sur le
                        côté front-end avec ReactJS.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">
                  <div class="row align-items-center gx-5">
                    <div class="col text-center text-lg-start mb-4 mb-lg-0">
                      <div class="bg-light p-4 rounded-4">
                        <div class="text-primary fw-bolder mb-2">
                          2020 - 2021
                        </div>
                        <div class="small fw-bolder">Projet personnel</div>
                        <div class="small text-muted">API</div>
                        <div class="small text-muted">
                          gestion de personnage
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div>
                        Mise en place d'une API Node.js visant à gérer les
                        personnages d'un dessin animé (Pokémon), accompagnée
                        d'une interface conçue à l'aide d'AngularJS
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <h2 class="text-secondary fw-bolder mb-4">Education</h2>
              <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">
                  <div class="row align-items-center gx-5">
                    <div class="col text-center text-lg-start mb-4 mb-lg-0">
                      <div class="bg-light p-4 rounded-4">
                        <div class="text-secondary fw-bolder mb-2">
                          2017 - 2020
                        </div>
                        <div class="mb-2">
                          <div class="small fw-bolder">
                            LICENCE Professionel
                          </div>
                          <div class="small text-muted">
                            Informatique éléctronique et télécommunication
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div>
                        Parcours professionnel à l'Université GSI de Madagascar,
                        axé sur les filières informatique, électronique et
                        télécommunications. Ce parcours m'a permis d'acquérir
                        des connaissances en tant qu'administrateur réseau et
                        développeur web, ainsi que dans la manipulation des
                        modules électroniques.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div class="pb-5"></div>
            <section>
              <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">
                  <div class="mb-5">
                    <div class="d-flex align-items-center mb-4">
                      <div class="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 me-3">
                        <i class="bi bi-tools"></i>
                      </div>
                      <h3 class="fw-bolder mb-0">
                        <span class="text-gradient d-inline">
                          Atouts professionnels
                        </span>
                      </h3>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3 mb-4">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Sécurisation réseau
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Développement web
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Développement mobile
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Arduino
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Docker
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Méthode agile SCRUM
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-0">
                    <div class="d-flex align-items-center mb-4">
                      <div class="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 me-3">
                        <i class="bi bi-code-slash"></i>
                      </div>
                      <h3 class="fw-bolder mb-0">
                        <span class="text-gradient d-inline">Technos</span>
                      </h3>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3 mb-4">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          REACT JS
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          GIT / GITLAB
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          JavaScript
                        </div>
                      </div>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Node.js
                        </div>
                      </div>
                      <div class="col mb-4 mb-md-0">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                           HTM/CSS/SCSS
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center bg-light rounded-4 p-3 h-100">
                          Bootstrap
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Parcours;
